function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import Tooltip from "./ChartTooltip";
import { FormatMetric, FormatDimension } from "../";

class TooltipCompare extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderSingle", () => {
      const _this$props = this.props,
            slice = _this$props.slice,
            metric = _this$props.metric,
            dimension = _this$props.dimension;
      const series = slice.points;
      const s1 = series[0].data || undefined;
      const metricType = s1.metricType,
            x = s1.x,
            y = s1.y,
            datetime = s1.datetime;
      let d;

      if (dimension.startsWith('ga:nth')) {
        d = datetime;
      } else {
        d = x;
      }

      return React.createElement(Tooltip, null, React.createElement("h2", {
        className: "admin-tooltip__title"
      }, React.createElement(FormatDimension, {
        name: dimension,
        value: d
      })), React.createElement("h3", {
        className: "admin-tooltip__value"
      }, React.createElement(FormatMetric, {
        type: metricType,
        value: y
      })));
    });
  }

  render() {
    const _this$props2 = this.props,
          slice = _this$props2.slice,
          metric = _this$props2.metric,
          dimension = _this$props2.dimension;
    const series = slice.points;
    let s1 = series[1].data || undefined;
    let s2 = series[0].data;

    if (s1 && !s2) {
      return this.renderSingle(s2);
    }

    let change, trending;

    if (s1.value > s2.value) {
      change = (s1.value - s2.value) / s1.value * 100;
      trending = "up";
    } else if (s2.value > s1.value) {
      change = (s2.value - s1.value) / s2.value * 100;
      trending = "down";
    } else {
      change = 0;
      trending = "flat";
    }

    if (dimension.startsWith('ga:nth')) {
      s1.d = s1.datetime;
      s2.d = s2.datetime;
    } else {
      s1.d = s1.x;
      s2.d = s2.x;
    }

    return React.createElement(Tooltip, null, React.createElement("h2", {
      className: "admin-tooltip__title"
    }, React.createElement(FormatDimension, {
      name: dimension,
      value: [s1.d, s2.d]
    })), React.createElement("h3", {
      className: "admin-tooltip__value"
    }, React.createElement(FormatMetric, {
      id: s1.metric,
      type: s1.metricType,
      value: s1.y
    })), React.createElement("p", {
      className: "admin-tooltip__change",
      "data-trending": trending
    }, React.createElement(FormatMetric, {
      type: "PERCENT",
      value: change
    })));
  }

}

export default TooltipCompare;